import { GroupResponse, OrganisationResponse, PractitionerData } from 'api';
import {
  isAdvancedUser,
  isGroupManager,
  isStandardUser,
  isSuperAdmin,
} from './role';

export type InviteEligibility =
  'CAN_BE_ADDED' | 'ALREADY_HAS_ACCESS' | 'CANNOT_BE_ADDED';

export type InviteEligibilityRequest = {
  inviter?: PractitionerData;
  invitee?: PractitionerData;
  inviteeOrganisations: OrganisationResponse[];
  selectedOrganisation?: OrganisationResponse;
  selectedOrganisationGroup?: GroupResponse;
};

const isInOrganisation = (
  organisations: OrganisationResponse[],
  organisationId: string,
) => organisations.some(({ id }) => id === organisationId);

const getInviteEligibility = ({
  inviter,
  invitee,
  inviteeOrganisations,
  selectedOrganisation,
  selectedOrganisationGroup,
}: InviteEligibilityRequest): InviteEligibility => {
  if (!inviter || invitee?.enabled === false) {
    return 'CANNOT_BE_ADDED';
  }
  if (isSuperAdmin(invitee?.role)) {
    if (
      isSuperAdmin(inviter.role) &&
      inviter.id !== invitee?.id &&
      (!selectedOrganisation ||
        (selectedOrganisation.visibility === 'PRIVATE' &&
          !isInOrganisation(inviteeOrganisations, selectedOrganisation.id)))
    ) {
      return 'CAN_BE_ADDED';
    }
    return 'ALREADY_HAS_ACCESS';
  }
  const isGroupScopedInviter =
    isGroupManager(inviter.role) || isAdvancedUser(inviter.role);

  if (isGroupScopedInviter && isGroupManager(invitee?.role)) {
    return 'CANNOT_BE_ADDED';
  }
  if (
    isGroupScopedInviter &&
    (isAdvancedUser(invitee?.role) || isStandardUser(invitee?.role)) &&
    selectedOrganisation
  ) {
    const isInviteeInSelectedOrganisationGroup =
      !!selectedOrganisationGroup &&
      selectedOrganisationGroup.organisations.some(({ id }) =>
        isInOrganisation(inviteeOrganisations, id),
      );

    return isInviteeInSelectedOrganisationGroup
      ? 'CAN_BE_ADDED'
      : 'CANNOT_BE_ADDED';
  }

  return 'CAN_BE_ADDED';
};

export default getInviteEligibility;
